var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreaterThan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.700781 11.8008C0.517448 11.6174 0.425781 11.3841 0.425781 11.1008C0.425781 10.8174 0.517448 10.5841 0.700781 10.4008L4.60078 6.50078L0.700781 2.60078C0.517448 2.41745 0.425781 2.18411 0.425781 1.90078C0.425781 1.61745 0.517448 1.38411 0.700781 1.20078C0.884114 1.01745 1.11745 0.925781 1.40078 0.925781C1.68411 0.925781 1.91745 1.01745 2.10078 1.20078L6.70078 5.80078C6.80078 5.90078 6.87178 6.00911 6.91378 6.12578C6.95511 6.24245 6.97578 6.36745 6.97578 6.50078C6.97578 6.63411 6.95511 6.75911 6.91378 6.87578C6.87178 6.99245 6.80078 7.10078 6.70078 7.20078L2.10078 11.8008C1.91745 11.9841 1.68411 12.0758 1.40078 12.0758C1.11745 12.0758 0.884114 11.9841 0.700781 11.8008Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterThan);
export default __webpack_public_path__ + "static/media/GreaterThan.0da6bb48d231c1586509d155d0231c55.svg";
export { ForwardRef as ReactComponent };